import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthRoutes } from '@bn/auth';
import { AuthService } from '@bn/auth/services';

import { NOT_PARTNER_QUERY_PARAM, PARTNER_ROLES } from '../constants';

export const partnerAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/', AuthRoutes.Auth, AuthRoutes.Login]);
  }

  const roles = (authService.authStoreValue?.user?.Roles ?? []) as unknown as string[];

  if (roles.some((r) => PARTNER_ROLES.includes(r))) {
    return true;
  }

  authService.logout(undefined, false);

  return router.createUrlTree(['/', AuthRoutes.Auth, AuthRoutes.Login], { queryParams: { [NOT_PARTNER_QUERY_PARAM]: 1 } });
};
